import { state } from "State";
import BaoBab from "baobab";
import databaseCache from "Services/databaseCache";
import { geo_aggregations_column_lookup } from "Lookups";
import config from "Config";

const cartoCss = {
  with_ramp: `#layer { polygon-fill: ramp([number], colorbrewer(${config.choropleth_color_ramp}), quantiles(8)); polygon-opacity: 0.6; line-width: 1; line-color: #ffffff; line-opacity: 0.22 }`,
  simple: `#layer { polygon-fill: ${config.map_color}; polygon-opacity: 0.4; line-width: 1; line-color: #fff; line-opacity: 0.4 }`
};

// set sql for map data
state.set(
  ["map_data", "sql"],
  BaoBab.monkey(["..", "domain_data"], domain_data =>
    databaseCache.getQuery(
      domain_data.community_value
        ? "MAP_QUERY"
        : "MAP_QUERY_NO_COMMUNITY_VALUE",
      domain_data
    )
  )
);

// set styling
state.set(
  ["map_data", "cartocss"],
  BaoBab.monkey(["..", "domain_data"], domain_data =>
    domain_data.geo_aggregation === "ste" ? cartoCss.simple : cartoCss.with_ramp
  )
);

// set interactivity requires column name with data to display
state.set(
  ["map_data", "interactivity"],
  BaoBab.monkey(["..", "domain_data"], domain_data =>
    domain_data.geo_aggregation == "ste"
      ? ["number"]
      : [
          geo_aggregations_column_lookup(
            domain_data.year,
            domain_data.geo_aggregation
          )
        ].concat("number")
  )
);



// WEBPACK FOOTER //
// ./services/mapStateCalculations.js